import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { CitiesSelectorComponent } from 'app/views/presentations/widgets/weather/citiesSelector.component';
import { WeatherWidget, WeatherWidgetComponent } from 'app/views/presentations/widgets/weather/weather.widget';

import { WidgetWrapperModule } from './../widgetWrapper.module';

@NgModule({
    imports: [
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CommonModule,
        WidgetWrapperModule.wrapWidget(WeatherWidget)
    ],
    declarations: [
        WeatherWidgetComponent,
        CitiesSelectorComponent
    ],
    entryComponents: [
        WeatherWidgetComponent
    ]
})
export class WeatherWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/weather/weather.module.ts